import { render, staticRenderFns } from "./InvoiceFrequency.vue?vue&type=template&id=6bb81dc2&scoped=true"
var script = {}
import style0 from "./InvoiceFrequency.vue?vue&type=style&index=0&id=6bb81dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb81dc2",
  null
  
)

export default component.exports